export * from './SelectedMaterialsSidebarFooter.types';
export { default as SelectedMaterialsSidebarFooter } from './SelectedMaterialsSidebarFooter';
